import { Button } from "@/components/ui/button";
import { MbscHeroDiagram } from "./mbscHeroDiagram";
import DotGrid from "@/components/ui/DotGrid";
import mbscLogo from "@/assets/mbsc.svg";

type MbscHeroProps = {
  onNavigate?: (path: string) => void;
};

export function MbscHero({ onNavigate }: MbscHeroProps) {
  const go = (path: string) => {
    if (onNavigate) onNavigate(path);
    else if (typeof window !== "undefined") {
      window.history.pushState({}, "", path);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };

  return (
    <section className="relative z-0 overflow-hidden border-b border-border/60 px-6 pb-20 pt-14 md:px-12 md:pb-28 md:pt-20">
      <div className="pointer-events-none absolute inset-0 z-0 opacity-80" aria-hidden>
        <DotGrid
          dotSize={4}
          gap={12}
          baseColor="rgba(0,0,0,0.12)"
          activeColor="rgba(0,0,0,0.34)"
          proximity={52}
          shockRadius={120}
          shockStrength={0.03}
          resistance={900}
          returnDuration={0.8}
        />
      </div>
      <div className="relative z-10 mx-auto max-w-6xl">
        <div className="grid items-center gap-12 md:grid-cols-[1.05fr_0.95fr]">
          <div className="mx-auto w-full max-w-2xl md:mx-0">
            <img
              src={mbscLogo}
              alt="MBSC"
              className="mb-6 h-7 w-auto opacity-90 md:h-8"
              loading="lazy"
              decoding="async"
            />
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
              MBSC — Monobundle Stablecoin Core
            </p>
            <h1
              className="mt-4 font-serif text-4xl font-light leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl"
              itemProp="headline"
            >
              日本円とステーブルコインを、シームレスにつなぐ。
            </h1>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">
              セキュリティ、通知、フロントエンド、バックエンド、マルチチェーン、管理画面を一括で提供するステーブルコイン発行のインフラ
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Button
                variant="default"
                size="lg"
                className="min-w-[180px]"
                onClick={() => {
                  const el = document.getElementById("contact");
                  el?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                導入のご相談
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="min-w-[180px]"
                onClick={() => go("/service/mbsc/docs")}
              >
                ドキュメント
              </Button>
            </div>
          </div>

          <div className="mx-auto w-full max-w-xl md:max-w-none">
            <MbscHeroDiagram />
          </div>
        </div>
      </div>
    </section>
  );
}
